module.exports = __webpack_public_path__ + "img/bg5.7df71a04.png";